// TOP 用コンポーネント
import TopSlider                  from '../../components/top-slider/top-slider.vue' ;
import SubTopSlider               from '../../components/top-slider/sub-top-slider.vue' ;
import RankingSwiper              from '../../views/home/RankingSwiper.vue' ;
import HomeNewItemsSwiper         from '../../views/home/NewItemsSwiper.vue' ;
import ColumnSwiper               from '../../views/home/ColumnSwiper.vue' ;
import NewsSwiper                 from '../../views/home/NewsSwiper.vue' ;
import ImportantEvent             from '../../views/home/ImportantEvent.vue' ;
import ImportantInformation       from '../../views/home/ImportantInformation.vue' ;
import HomeSaleItemsSwiper        from '../../views/home/SaleItemsSwiper.vue' ;
import HomeSaleItemsReservation   from '../../views/home/SaleItemsReservation.vue' ;
import OverlayBanner              from '../../components/OverlayBanner.vue' ;
import RecommendTalents           from '../../views/talent/RecommendTalents.vue';

window.Vue.component('top-slider',                  TopSlider);
window.Vue.component('sub-top-slider',              SubTopSlider);
window.Vue.component('ranking-swiper',              RankingSwiper);
window.Vue.component('home-new-items-swiper',       HomeNewItemsSwiper);
window.Vue.component('column-swiper',               ColumnSwiper);
window.Vue.component('news-swiper',                 NewsSwiper);
window.Vue.component('important-event',             ImportantEvent);
window.Vue.component('important-information',       ImportantInformation);
window.Vue.component('home-sale-items-swiper',      HomeSaleItemsSwiper);
window.Vue.component('home-sale-items-reservation', HomeSaleItemsReservation);
window.Vue.component('overlay-banner',              OverlayBanner);
window.Vue.component('recommend-talents', RecommendTalents);

// お知らせ
import InfoList  from '../../views/info/List.vue';
window.Vue.component('info-list', InfoList);
